import React from 'react';
import './NewsContent.css';

const NewsContent = ({ date, text, link }) => {
  return (
    <article className="news-content">
      <div className="grey-divider"></div>
      <a href={link} target="_blank" rel="noopener noreferrer" className="news-link">
        <div className="news">
          <time className="news-day" dateTime={date.replace(/\./g, '-')}>{date}</time>
          <p className="news-text">{text}</p>
        </div>
      </a>
    </article>
  );
}

export default NewsContent;